export default [
  {
    path: "/tools",
    name: "tools",
    meta: { title: "实用小工具" },
    component: () => import("@/layouts/PageLayouts.vue"),
    children: [
      {
        path: "/tools/areaAnalysis",
        name: "areaAnalysis",
        component: () => import("@/views/tools/areaAnalysis/index.vue"),
        meta: { title: "用地面积分析" },
      },
      {
        path: "/tools/tdjcb",
        name: "tdjcb",
        component: () => import("@/views/tools/tdjcb/index.vue"),
        meta: { title: "土地金及拆补抵减增值税计算器" },
      },
      {
        path: "/tools/kfjjfrypb",
        name: "kfjjfrypb",
        component: () => import("@/views/tools/kfjjfrypb/index.vue"),
        meta: { title: "开发间接费人员配比" },
      },
      {
        path: "/tools/shzy",
        name: "shzy",
        component: () => import("@/views/tools/shzy/index.vue"),
        meta: { title: "审核指引" },
      },
      {
        path: "/tools/jzmjAnalysis",
        name: "jzmjAnalysis",
        component: () => import("@/views/tools/jzmjAnalysis/index.vue"),
        meta: { title: "建筑面积分析" },
      },
      {
        path: "/tools/zjqybd",
        name: "zjqybd",
        component: () => import("@/views/tools/zjqybd/index.vue"),
        meta: { title: "工程造价区域对比" },
      },
    ],
  },
];